<ng-container *ngTemplateOutlet="renderGroup; context: groupContext(data, null)"></ng-container>

<ng-template #renderGroup let-group let-parent="parent">
  <div class="q-switch-row">
    @if (switchGroupTemplate; as switchGroup) {
      <ng-container *ngTemplateOutlet="switchGroup.template; context: switchContext(group)"></ng-container>
    }
    <div class="q-button-group">
      @if (buttonGroupTemplate; as buttonGroup) {
        <ng-container *ngTemplateOutlet="buttonGroup.template; context: buttonContext(group, parent)"></ng-container>
      }
    </div>
  </div>

  @if (group.rules) {
    <ul class="q-tree">
      @for (item of group.rules; track item) {
        <li class="q-rule" [class.q-ruleset]="asGroup(item)">
          @if (asGroup(item); as nested) {
            <ng-container *ngTemplateOutlet="renderGroup; context: groupContext(nested, group)"></ng-container>
            @if (!nested.rules.length) {
              <p class="q-empty-warning">{{ emptyMessage ?? ('QUERY_BUILDER.empty_group' | translate) }}</p>
            }
          } @else {
            @if (asRule(item); as rule) {
              @if (removeButtonTemplate; as removeButton) {
                <div class="q-remove-button">
                  <ng-container *ngTemplateOutlet="removeButton.template; context: removeContext(rule, group)"></ng-container>
                </div>
              }
              @if (fieldTemplate; as field) {
                <div class="q-field-control">
                  <ng-container *ngTemplateOutlet="field.template; context: fieldContext(rule)"></ng-container>
                </div>
              }
              @if (operatorTemplate; as operator) {
                <div class="q-operator-control">
                  <ng-container *ngTemplateOutlet="operator.template; context: operatorContext(rule)"></ng-container>
                </div>
              }
              @if (inputTemplate(rule); as input) {
                <div class="q-input-control">
                  <ng-container *ngTemplateOutlet="input; context: inputContext(rule)"></ng-container>
                </div>
              }
            }
          }
        </li>
      }
    </ul>
  }
</ng-template>
